import React, { Component } from "react";
import { Route, NavLink, Routes } from "react-router-dom";
import { withRouter, RenderRoute } from "../../utils/router";
import { withRequest } from "../../utils/request";
import Loader from "../general/Loader";
import Edit from "./Edit";
import Ajustes from "./Ajustes";
import Compras from "./Compras";
import Gastos from "./Gastos";
import GastosGenerales from "./GastosGenerales";
import { auth } from "../../utils/auth";
import { getLink } from "../../utils/helpers";
import EditFotos from "./EditFotos";
import { itemContext } from "./itemContext";

class Layout extends Component {
    state = {
        item: {},
        loading: true,
        almacenes: [],
        ubicaciones: [],
        grupos: [],
    };

    componentDidMount() {
        this.getItem();
        this.getTable("grupos");
        this.getTable("almacenes");
        this.getTable("ubicaciones");
    }

    getItem = async (url = null) => {
        const id = this.props.match.params.id;
        url = url ? url : "items/" + id;
        const item = await this.props.request(url);

        if (item.success) {
            this.setState({
                item: item.data,
                loading: false,
            });
        }
    };
    getTable = async (url = null) => {
        const table = await this.props.request(url);

        if (table.data) {
            this.setState({
                [url]: table.data,
                loading: false,
            });
        }
    };
    render() {
        const { loading, item, almacenes, ubicaciones, grupos } = this.state;

        if (loading) {
            return <Loader />;
        }

        return (
            <div>
                <div className='page-header'>
                    <h1 className='page-title'>{item.nombre}</h1>
                </div>
                <div className='row'>
                    <div className='col-md-3 page-sidebar' style={{maxWidth: '250px'}}>
                        <ul className='list-unstyled page-sidebar__menu'>
                            <li>
                                <NavLink
                                    to={getLink(
                                        `/inventario/${item.id}/informacion`
                                    )}
                                    end
                                    className='nav-link'>
                                    Información General
                                </NavLink>
                            </li>
                            <li>
                                {item.fotos && (
                                            <NavLink
                                                to={getLink(
                                                    `/inventario/${item.id}/fotos`
                                                )}
                                                end
                                                className='nav-link'>
                                                Fotos
                                            </NavLink>
                                        )
                                    }
                            </li>
                            <li>
                                <NavLink
                                    to={getLink(
                                        `/inventario/${item.id}/compras`
                                    )}
                                    end
                                    className='nav-link'>
                                    Compras
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to={getLink(
                                        `/inventario/${item.id}/gastos`
                                    )}
                                    end
                                    className='nav-link'>
                                    Gastos
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to={getLink(
                                        `/inventario/${item.id}/ajustes`
                                    )}
                                    end
                                    className='nav-link'>
                                    Ajustes
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                    <div className='col p-l-45'>
                        <Routes>
                            <Route
                                path='informacion'
                                element={<RenderRoute render={(props) => (
                                    <itemContext.Provider value={item}>
                                        <Edit
                                            {...props}
                                            almacenes={almacenes}
                                            ubicaciones={ubicaciones}
                                            grupos={grupos}
                                        />
                                    </itemContext.Provider>
                                )} />}
                            />
                            <Route
                                path='fotos'
                                element={<RenderRoute render={(props) => (
                                    <EditFotos
                                        {...props}
                                        item={item}
                                    />
                                )} />}
                            />
                            <Route
                                path='ajustes'
                                element={<RenderRoute render={(props) => (
                                    <Ajustes
                                        {...props}
                                        item={item}
                                        getItem={this.getItem}
                                    />
                                )} />}
                            />
                            <Route
                                path='compras'
                                element={<RenderRoute render={(props) => (
                                    <Compras {...props} item={item} />
                                )} />}
                            />
                            <Route
                                path='gastos'
                                element={<RenderRoute render={(props) => (
                                    <Gastos {...props} item={item} />
                                )} />}
                            />
                            <Route
                                path='gastos-generales'
                                element={<RenderRoute render={(props) => (
                                    <GastosGenerales {...props} item={item} />
                                )} />}
                            />
                        </Routes>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(withRequest(Layout));
